module.exports = __webpack_public_path__ + "static/media/logo-cydocs-color.ae0ade0f.png";